module.exports = __webpack_public_path__ + "img/4制御工学5_8_3.9a19fb0e.png";